export default __webpack_public_path__ + "static/media/st2.c923451e.jpeg";